import React from "react";
import { MapPin, ArrowRight } from "lucide-react";

/**
 * Reusable "Sister site" promo strip. Shows a partner-site favicon/logo
 * alongside a short pitch and a Visit CTA. Used on the Home page to send
 * SJDS visitors to Popoyo.app (sister SJDS/surf hub) and to
 * DigitalNomadNicaragua.com (remote-work partner).
 */
export default function SisterSiteStrip({
  href,
  logoSrc,
  logoAlt,
  logoBg = "#FFFFFF",
  pitchLead,
  pitchBrand,
  accent = "var(--teal)",
  bgGradient = "linear-gradient(90deg, #F5F7F0 0%, #E5F3F1 100%)",
  borderColorVar = "var(--teal)",
  testId,
  visitLabel = "Visit",
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label={`${pitchLead} ${pitchBrand}`}
      className="block mb-4 rounded-2xl overflow-hidden border shadow-[0_6px_20px_-10px_rgba(46,196,182,0.4)] hover:shadow-[0_10px_28px_-10px_rgba(46,196,182,0.6)] hover:-translate-y-0.5 transition-all"
      style={{ background: bgGradient, borderColor: `${borderColorVar}` }}
    >
      <div className="flex items-center gap-3 sm:gap-4 px-4 sm:px-5 py-3">
        <div
          className="w-11 h-11 sm:w-12 sm:h-12 rounded-2xl flex items-center justify-center shrink-0 overflow-hidden"
          style={{ background: logoBg }}
          aria-hidden="true"
        >
          <img
            src={logoSrc}
            alt={logoAlt}
            loading="lazy"
            className="w-full h-full"
            style={{ objectFit: "contain" }}
          />
        </div>

        <div className="flex-1 min-w-0">
          <p
            className="text-[10px] sm:text-[11px] uppercase tracking-widest font-bold flex items-center gap-1"
            style={{ color: accent }}
          >
            <MapPin className="w-3 h-3" /> Sister site
          </p>
          <p
            className="text-sm sm:text-base font-bold text-[color:var(--ink)] leading-tight"
            style={{ fontFamily: "Outfit" }}
          >
            {pitchLead}{" "}
            <span style={{ color: accent }}>{pitchBrand}</span>
          </p>
        </div>

        <span
          className="pill inline-flex items-center gap-1 px-3 py-1.5 text-xs sm:text-sm font-bold text-white whitespace-nowrap"
          style={{ background: accent }}
        >
          {visitLabel} <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </a>
  );
}
